import { Directive, Input, output, input } from '@angular/core';
import { DropdownState } from '../select/select.component';

export const DropdownFormControlDirectiveInputs = [
  'bindValue',
  'bindLabel',
  'selectAllLabel',
  'panelStyleClass',
  'clearable',
  'appendTo',
];
export const DropdownFormControlDirectiveOutputs = ['clear', 'dropdownStateChange'];

@Directive({
  selector: '[uiDropdownFormControl]',
  standalone: true,
})
export class DropdownFormControlDirective {
  readonly bindValue = input('id');

  readonly bindLabel = input('label');

  readonly panelStyleClass = input<string>();

  @Input()
  clearable = false;

  readonly appendTo = input('body');

  readonly selectAllLabel = input('Vybrat vše');

  readonly clear = output<void>();

  readonly dropdownStateChange = output<DropdownState>();
}
